module.exports = __webpack_public_path__ + "26ee887282519008e13d35bd2ad362a8.svg";